<template>
  <div class="wrapper box box_v">
    <div class="mini-header-wrapper box">
      <switch-tab
        :arr="arrtab"
        :selectIndex="selectIndex"
        @changeTab="changeTab"
        v-if="$store.state.childrenInd == 0"
      ></switch-tab>
      <div class="mini-header">{{ title }}</div>
    </div>
    <div class="item-wrapper box_f1" v-if="$store.state.childrenInd == 1">
      <Card class="card-wrapper1">
        <div class="box set-content">
          <div class="box set-item">
            <div class="box_f1 set-title">实名认证设置</div>
            <div class="box_f1 set-shuoming">
              说明: 可设置居民从{{
                appType == "ctt"
                  ? "丛台先锋"
                  : appType == "dxbst"
                  ? "东乡先锋"
                  : "先锋e家"
              }}小程序实名认证提交的信息
            </div>
            <div class="box_f1 set-edit" @click="setAuth">
              <i class="iconfont icon-bianji1"></i>
              编辑
            </div>
          </div>
        </div>
        <div class="box set-content">
          <div class="box set-item">
            <div class="box_f1 set-title">积分设置</div>
            <div class="box_f1 set-shuoming">
              说明: 可设置党员从{{
                appType == "ctt"
                  ? "丛台先锋"
                  : appType == "dxbst"
                  ? "东乡先锋"
                  : "先锋e家"
              }}小程序获得的积分
            </div>
            <div class="box_f1 set-edit" @click="setJf">
              <i class="iconfont icon-bianji1"></i>
              编辑
            </div>
          </div>
        </div>
      </Card>
    </div>
    <!-- <div class="item-wrapper box_f1" v-else> -->
    <!-- <div class="item-header" v-show="selectIndex==0">民生通</div>
      <div class="card box" v-show="selectIndex==0"> -->
    <div class="item-wrapper box_f1" v-else>
      <!-- <div class="item-header" v-show="selectIndex==0">民生通</div> -->
      <Card
        :show="selectIndex == 0"
        v-show="selectIndex == 0"
        style="height: 100%"
      >
        <div
          class="t-content box"
          style="align-items: center"
          v-for="(item, index) in setList"
          :key="index"
        >
          <p class="box t-title">{{ item.title }}</p>
          <div
            class="img-con box"
            style="align-items: center; display: -webkit-flex"
          >
            <span>示例</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <img :src="item.src" alt="" />
          </div>
          <p class="box t-shuoming">说明: {{ item.shuoming }}</p>
          <div class="box_f1 set-edit" @click="goSet(index)">
            <i class="iconfont icon-bianji1"></i>
            编辑
          </div>
        </div>
        <Spin fix v-if="loading"></Spin>
      </Card>
      <!-- <div class="card box" v-show="selectIndex==0">
        <Card
          class="card-wrapper"
          :padding="padding"
          shadow
          v-for="(item,index) in mst"
          :key="index"
        >
          <div>
            <div class="box top-wrapper">
              <div class="text1">{{item.name}}</div>
              <i-switch v-model="item.isShow" @on-change="changeSelect(index)" />
            </div>
            <div class="text2">{{item.remark}}</div>
          </div>
        </Card>
      </div> -->
      <Card
        :show="selectIndex == 1"
        v-show="selectIndex == 1"
        class="card-wrapper1"
      >
        <div class="box set-content">
          <div class="box set-item">
            <div class="box_f1 set-title">实名认证设置</div>
            <div class="box_f1 set-shuoming">
              说明: 可设置居民从民生通小程序实名认证提交的信息
            </div>
            <div class="box_f1 set-edit" @click="setAuth">
              <i class="iconfont icon-bianji1"></i>
              编辑
            </div>
          </div>
        </div>
        <div class="box set-content">
          <div class="box set-item">
            <div class="box_f1 set-title">积分设置</div>
            <div class="box_f1 set-shuoming">
              说明: 可设置居民从民生通小程序获得的积分
            </div>
            <div class="box_f1 set-edit" @click="setJf">
              <i class="iconfont icon-bianji1"></i>
              编辑
            </div>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import switchTab from "./components/switchTab";
var that;
export default {
  name: "mstSetting",
  components: {
    switchTab,
  },
  data() {
    return {
      shangbao: false,
      weishequ: false,
      shenghuofuwu: false,
      padding: 0,
      mst: "", //民生通配置
      arrtab: ["页面设置", "功能设置"],
      selectIndex: 0, // tab 索引
      indexList: ["banner", "service", "setting"], //索引列表
      setList: [],
      loading: false,
      title: "",
    };
  },
  methods: {
    changeTab(index) {
      this.selectIndex = index;
    },
    setAuth() {
      if (this.$store.state.childrenInd == 1) {
        this.$router.push({ name: "xfejAuth" });
        return;
      }
      this.$router.push({ name: "setAuth" });
    },
    xfejAuth() {
      this.$router.push({ name: "xfejAuth" });
    },
    setJf() {
      this.$router.push({
        name: "setJf",
        query: {
          apptype: this.$store.state.childrenInd
            ? this.appType == "ctt"
              ? "ctxf"
              : this.appType == "dxbst"
              ? "dxxf"
              : "xfej"
            : "mst",
        },
      });
    },
    changeSelect(index) {
      var url = this.urlobj.setMiniSet;
      var id = this.mst[index].id;
      var isShow = this.mst[index].isShow ? 1 : 0;
      this.$post(url, {
        id,
        isShow,
      }).then((res) => {});
    },
    getSetting() {
      var url = this.urlobj.getMiniSet;
      this.$get(url).then((res) => {
        that.mst = res.rows[0].mst
          .map((item) => {
            return {
              name: item.moduleName,
              remark: item.remark,
              id: item.id,
              isShow: item.isShow == 1 ? true : false,
              moduleValue: item.moduleValue,
            };
          })
          .filter((item) => {
            return (
              item.moduleValue == "event_report" ||
              item.moduleValue == "life_service" ||
              item.moduleValue == "mini_community" ||
              item.moduleValue == "activity" ||
              item.moduleValue == "vote" ||
              item.moduleValue == "meeting" ||
              item.moduleValue == "knowledge" ||
              item.moduleValue == "community_event" ||
              item.moduleValue == "phone_book" ||
              item.moduleValue == "parking"
            );
          });
      });
    },
    goSet(index) {
      var id = this.setList[index].id;
      if (index == 0) {
        this.$router.push({ name: "bannerSet" });
      } else {
        var type = this.indexList[index];
        var isShow = index == 1 ? this.setList[index].isShow : "";
        console.log(isShow);
        this.$router.push({ name: "mstSet", query: { type, id, isShow } });
      }
    },
    getSettingList() {
      this.loading = true;
      var url = this.urlobj.getSettingList;
      var data = {
        pageNum: 0,
        pageSize: 0,
        communityId: this.$store.state.streetorcommunityid,
      };
      this.$post(url, data).then((res) => {
        var list = res.rows.map((item, i) => {
          let obj = {
            title: item.title,
            src: item.iconUrl,
            shuoming: item.content,
            id: item.id,
          };
          if (i == 1) {
            obj.isShow = item.isShow;
          }
          return obj;
        });
        // list[1].isShow = res.rows[1].isShow;
        this.setList = list;
        this.loading = false;
      });
    },
  },
  updated() {
    console.log("进入updated方法");
    this.title = this.$route.query.title;
  },
  mounted() {
    // this.$router.go(0);
    if (this.$store.state.childrenInd == 1) {
      // this.title='丛台先锋设置'
      this.title = this.$route.query.title;
    } else {
      switch (this.$store.state.apptype) {
        case "mst":
          this.title = "民生通设置";
          break;
        case "ipy":
          this.title = "i濮阳设置";
          break;
        case "ctt":
          this.title = "丛台通设置";
          break;
        case "lzt":
          this.title = "临漳购设置";
          break;
        case "dxbst":
          this.title = "东乡百事通设置";
          break;
      }
    }

    console.log("mstSetting mounted");
    that = this;
    // this.getSetting();
    this.getSettingList();
  },
  computed: {
    appType: function () {
      return this.$store.state.apptype;
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(from, to);
    var selectIndexList = ["setAuth", "setJf", "epidemicSet", "epidemicNotice"];
    next((vm) => {
      if (selectIndexList.indexOf(from.name) > -1) {
        vm.selectIndex = 1;
      }
    });
  },
};
</script>

<style scoped lang="less">
.wrapper {
  height: 100%;
}
.mini-header-wrapper {
  display: flex;
  /*height: 30px;*/
  line-height: 30px;
  padding: 30px 0;
  justify-content: center;
  position: relative;
}
.mini-header {
  font-size: 25px;
  text-align: center;
}
.item-wrapper {
  padding: 0 20px 20px;
}
.item-header {
  font-size: 17px;
  margin-bottom: 20px;
}
.card {
  flex-wrap: wrap;
}
.card-wrapper {
  width: 370px;
  padding: 20px;
  margin: 0 20px 20px 0;
}
.top-wrapper {
  justify-content: space-between;
  margin-bottom: 20px;
}
.text1 {
  font-size: 16px;
}
.text2 {
  font-size: 15px;
  color: #999;
}
.ivu-switch:focus {
  box-shadow: none;
}
.card-wrapper1 {
  width: 99%;
  height: 100%;
  padding-left: 4px;
}
.set-content {
  width: 100%;
  padding-bottom: 30px;
  padding-top: 30px;
  border-bottom: 1px solid #eee;
}
.set-item {
  width: 70%;
}
.set-title {
  font-size: 18px;
}
.set-shuoming {
  margin-left: -20%;
  font-size: 16px;
}
.set-edit {
  font-size: 16px;
  color: #677a9e;
}
.t-content {
  padding: 30px 20px;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
}
.t-title {
  font-size: 20px;
  margin-right: 105px;
}
.img-con {
  margin-right: 96px;
}
.img-con img {
  width: 335px;
}
.t-shuoming {
  width: 500px;
}
/deep/ .ivu-card-body {
  padding-top: 0;
  padding-right: 0;
}
</style>
